function axiomsApiDomain() {
    let url
    switch (location.hostname) {
        case 'app.us.axioms.io':
            url = 'axioms.us.axioms.io'
            break;

        case 'control.us.axioms.io':
            url = 'axioms.us.axioms.io'
            break;

        case 'control.us.uat.axioms.io':
            url = 'axioms.us.uat.axioms.io'
            break;

        default:
            url = 'axioms.example.com'
            break;
    }
    return url
}

export default axiomsApiDomain;